module.exports = __webpack_public_path__ + "static/media/Storage-how-it-works-6.6eb5a82c.jpg";